// CustomPagination.js
import React, { useState } from 'react';
import {IconButton, Typography, Box, Select, MenuItem } from '@mui/material';

const style = {
    page: {
        minWidth: "24px",
        height: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Poppins-Regular",
        color: "#00B2E3",
        fontSize: "13px",
        fontWeight: "400",
        backgroundColor: "#fff",
        borderRadius: "6px",
        border: '1px solid #00B2E3'
    },
    wrapperBottom: {
        display: 'flex', 
        // justifyContent: 'flex-end', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom:'5px',
        flexWrap: "wrap"
    },
    wrapperTop: {
        display: 'flex', 
        // justifyContent: 'flex-end', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: "5px"
    },
    pageWrapper: {
        display: "flex",
        alignItems: "center", 
    },
    of: {
        fontFamily: "Poppins-Regular",
        fontWeight: "400",
        color: "#CCCFD1",
        fontSize: 12,
        marginLeft: 10,
        marginRight: 10
    },
    p: {
        fontFamily: "Poppins-Regular",
        fontWeight: "400",
        color: "#25313C",
        fontSize: 12,
    }
}

function CustomPagination({ count, last_page ,page, rowsPerPage, onPageChange, onRowsPerPageChange, position, numberOfRecords  }) {
    const [isOpen, setIsOpen] = useState(false);
    const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const totalPages = last_page ? last_page : Math.ceil(count / rowsPerPage);


    if(totalPages > 0){
        return (
            <div style={position === "top" ? style.wrapperTop : style.wrapperBottom}>
                <div className='d-flex'>
                    <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
                        <img src="/admin-icons/arrow-right-double.svg" alt="first-page"/>
                    </IconButton>
                    <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page" style={{marginRight: "10px"}}>
                        <img src="/admin-icons/arrow-right-one.svg" alt="first-page"/>
                    </IconButton>
                    <div style={style.pageWrapper}>
                    <span style={style.page}>{page + 1}</span> 
                    <span style={style.of}>of</span> 
                    <span style={style.page}>{totalPages}</span>
                    </div>
                    <IconButton
                        style={{marginLeft: "10px"}}
                        onClick={handleNextButtonClick}
                        disabled={page >=  parseInt(totalPages) - 1}
                        aria-label="next page"
                    >
                        <img src="/admin-icons/arrow-right-one.svg" alt="first-page" style={{transform: "rotate(180deg)"}}/>
                    </IconButton>
                    <IconButton
                        onClick={handleLastPageButtonClick}
                        disabled={page >=  parseInt(totalPages) - 1}
                        aria-label="last page"
                    >
                        <img src="/admin-icons/arrow-right-double.svg" alt="first-page" style={{transform: "rotate(180deg)"}}/>
                    </IconButton>
                </div>
                <Box display="flex" alignItems="center" style={{marginRight: 20}}>
                    <p style={style.p}>Rows per page:</p>
                    <Select
                        value={rowsPerPage}
                        onChange={onRowsPerPageChange}
                        variant="standard"
                        disableUnderline
                        onOpen={() => setIsOpen(true)}
                        onClose={() => setIsOpen(false)}
                        sx={{
                            fontSize: '12px', 
                            fontFamily: "Poppins-Regular",
                            fontWeight: "400",
                            color: "#25313C",
                            '& .MuiSelect-select': {
                            padding: '4px 20px 4px 8px!important',
                            },
                            '& .MuiSvgIcon-root': {
                            fontSize: '20px',
                            },
                        }}
                    >
                        {[10, 25, 50, 100].map((rows) => (
                            <MenuItem key={rows} value={rows}>
                                {rows}
                            </MenuItem>
                        ))}
                    </Select>
                    <h4 style={{color: '#c3c3c3', marginLeft: '2px', fontFamily: 'Poppins-Regular', fontSize: '12px'}}>/ {numberOfRecords} {numberOfRecords === 1 ? 'result' : 'results'}</h4>
                </Box>
            </div>
        );
    }
    else{
        return <div></div>;
    }

}

export default CustomPagination;
